export default __webpack_public_path__ + "static/media/cine-one-21-logo.413b6b1e.svg";